import React from 'react';
import PropTypes from 'prop-types';

import {
  SECURITY_LEVEL_LABELS,
  SECURITY_LEVEL_VALUES,
} from '../../constants/securityLevels';
import style from '../../style/components/signin/SecurityStrengthIndicator.module.scss';

const getLineClass = (index, level) => {
  if (level === SECURITY_LEVEL_VALUES.fair && index === 0) return style.fair;
  if (level === SECURITY_LEVEL_VALUES.moderate && index < 2)
    return style.moderate;
  if (level === SECURITY_LEVEL_VALUES.strong && index < 3) return style.strong;
  if (level === SECURITY_LEVEL_VALUES.veryStrong) return style.veryStrong;
  return '';
};

const SecurityStrengthIndicator = ({ level }) => (
  <div data-testid="mfa-strength-indicator" className={style.indicator}>
    <div className={style.lines}>
      {[0, 1, 2, 3].map((i) => (
        <span key={i} className={`${style.line} ${getLineClass(i, level)}`} />
      ))}
    </div>
    <span className={style.label}>{SECURITY_LEVEL_LABELS[level]}</span>
  </div>
);

SecurityStrengthIndicator.propTypes = {
  level: PropTypes.string.isRequired,
};

export default SecurityStrengthIndicator;
